export const STATE = {
    SUCCESS: "SUCCESS",
    LOADING: "LOADING",
    IDLE: "IDLE",
    ERROR: "ERROR",
  };


export const UPLOAD = {
  UPLOAD:"UPLOAD",
  UPLOADING:"UPLOADING",
  UPLOADED:"UPLOADED"
}